import React from 'react';
import { Card, CardContent, Typography, Button, Skeleton } from '@mui/material';

import theme from '../../../../theme';
import { formatStatus, getStatusColor, getStatusHoverColor } from '../utils';

interface PaymentHistoryCardProps {
  title: string;
  amount: string;
  status: string;
  onClick: () => void;
}

const PaymentHistoryCard: React.FC<PaymentHistoryCardProps> = ({
  title,
  amount,
  status,
  onClick,
}) => {
  return (
    <Card sx={{ borderRadius: 10, mb: 1, cursor: 'pointer' }} onClick={onClick}>
      <CardContent>
        <Typography
          variant="body1"
          sx={{ marginBottom: 2, color: theme.palette.text.secondary }}
        >
          {title ?? 'No Payment description available'}
        </Typography>
        <Typography variant="h6" gutterBottom sx={{ marginBottom: 2 }}>
          {amount ?? '--'}
        </Typography>
        <Button
          variant="contained"
          fullWidth
          sx={{
            backgroundColor: getStatusColor(status),
            '&:hover': {
              backgroundColor: getStatusHoverColor(status),
            },
          }}
          onClick={(e) => e.preventDefault()}
        >
          {formatStatus(status)}
        </Button>
      </CardContent>
    </Card>
  );
};

export default PaymentHistoryCard;

export const PaymentHistoryCardSkeleton = () => (
  <Card sx={{ borderRadius: 10, mb: 1 }}>
    <CardContent>
      <Skeleton variant="text" width="80%" height={28} sx={{ mb: 2 }} />
      <Skeleton variant="text" width="40%" height={24} sx={{ mb: 2 }} />
      <Skeleton
        variant="rectangular"
        width="100%"
        height={36}
        sx={{ borderRadius: 2 }}
      />
    </CardContent>
  </Card>
);
